import { render, staticRenderFns } from "./appletsGoodList.vue?vue&type=template&id=d274c914&"
import script from "./appletsGoodList.vue?vue&type=script&lang=js&"
export * from "./appletsGoodList.vue?vue&type=script&lang=js&"
import style0 from "./appletsGoodList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports